<template>
  <v-row>
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="5"
    >
      <div
        v-if="loading1"
        :style="styleObject"
        class="text-center"
      >
        <br><br>
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error1 }}
      </div>
      <div
        v-else
      >
        <br><br>
        <div v-if="enableTable1">
          <div class="d-flex justify-end align-center px-4">
            <dashboard-excel-export
              :headers="headersFaturamento"
              :table="dadosFaturamentoClienteExcel"
              :titulo-relatorio="tituloRelatorio"
              :arquivo="arquivo"
              :enable-btn="enableBtn"
              :data-inicial="dataInicial1"
              :data-final="dataFinal1"
              :empresa-select="empresaSelect1"
              :cidade-select="cidades1"
              :vendedor-select="vendedores1"
              :area-select="areas1"
              :rede-select="redes1"
              :segmento="segmento"
              :produto="produtos1"
            />
          </div>
          <br>
          <div
            id="idTable"
            style="overflow-x: auto;"
          >
            <table
              style="width: 100%; color: black; border-collapse: collapse;"
              class="elevation-1"
            >
              <thead>
                <tr>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    @click="mudarOrdenacaoFaturamentoCliente('cliente')"
                  >
                    Cliente
                    <v-icon small>
                      {{ ordenarPorFaturamentoCliente === 'cliente' ? (ordenacaoDecrescenteFaturamentoCliente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                    </v-icon>
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    @click="mudarOrdenacaoFaturamentoCliente('data')"
                  >
                    Última venda
                    <v-icon small>
                      {{ ordenarPorFaturamentoCliente === 'data' ? (ordenacaoDecrescenteFaturamentoCliente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                    </v-icon>
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    @click="mudarOrdenacaoFaturamentoCliente('volume')"
                  >
                    Volume
                    <v-icon small>
                      {{ ordenarPorFaturamentoCliente === 'volume' ? (ordenacaoDecrescenteFaturamentoCliente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                    </v-icon>
                  </th>
                </tr>
              </thead>
              <tbody
                v-for="item in dadosFaturamentoCliente"
                :key="item.id"
              >
                <tr>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: left;"
                  >
                    {{ item.cliente }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: center;"
                  >
                    {{ item.dataExibicao }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: right;"
                  >
                    {{ item.volume }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else>
          <br><br>
          <h4 class="text-center">
            Para exibição dos dados favor selecionar pelo menos 1 produto
          </h4>
        </div>
      </div>
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="7"
    >
      <div
        v-if="loading1"
        :style="styleObject"
        class="text-center"
      >
        <br><br>
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error1 }}
      </div>
      <div
        v-else
      >
        <br><br>
        <div class="d-flex justify-end align-center px-4">
          <dashboard-excel-export
            :headers="headersFaturamentoClienteProduto"
            :table="dadosFatClienteProdutoExcel"
            :titulo-relatorio="tituloRelatorio"
            :arquivo="arquivo"
            :enable-btn="enableBtn"
            :data-inicial="dataInicial1"
            :data-final="dataFinal1"
            :empresa-select="empresaSelect1"
            :cidade-select="cidades1"
            :vendedor-select="vendedores1"
            :area-select="areas1"
            :rede-select="redes1"
            :segmento="segmento"
            :produto="produtos1"
            :tabela-agrupada="true"
          />
        </div>
        <br>
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                />
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center; cursor: pointer;"
                  @click="mudarOrdenacaoFaturamentoProduto('cliente')"
                >
                  Cliente
                  <v-icon small>
                    {{ ordenarPorFaturamentoProduto === 'cliente' ? (ordenacaoDecrescenteFaturamentoProduto ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center; cursor: pointer;"
                  @click="mudarOrdenacaoFaturamentoProduto('volume')"
                >
                  Volume
                  <v-icon small>
                    {{ ordenarPorFaturamentoProduto === 'volume' ? (ordenacaoDecrescenteFaturamentoProduto ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
              </tr>
            </thead>
            <tbody
              v-for="(item, index) in dadosFatClienteProduto"
              :key="item.id"
            >
              <!-- Linha principal -->
              <tr>
                <td style="text-align: center;">
                  <button @click="toggleExpand(index)">
                    {{ expanded.includes(index) ? '▲' : '▼' }}
                  </button>
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.cliente }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.volumeExibicao }}
                </td>
              </tr>
              <!-- Linha expandida -->
              <tr
                v-if="expanded.includes(index)"
                :key="'expanded-' + item.id"
              >
                <td colspan="10">
                  <table
                    id="tableExpandida"
                    style="width: 100%; border-collapse: collapse; margin-top: 10px;"
                  >
                    <thead>
                      <tr>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center/* ; width: 23.8%; */"
                        >
                          Produto
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Última venda
                        </th>
                        <th
                          id="dadoMovimentacaoHeader"
                          style="text-align: center;"
                        >
                          Volume
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(sub, idx) in item.produtos"
                        :key="idx"
                      >
                        <td
                          id="dadoMovimentacao"
                          style="text-align: left;"
                        >
                          {{ sub.produto }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: center;"
                        >
                          {{ sub.dataExibicao }}
                        </td>
                        <td
                          id="dadoMovimentacao"
                          style="text-align: right;"
                        >
                          {{ sub.volumeExibicao }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import FluxoVenda from '../../../../services/fluxovenda'
  import eventEmit from '../core/EventoEmit'

  export default {
    name: 'ShowDadosComparativoFaturamento',
    emits: ['setDadosFaturamentoClienteTempo', 'setDadosFaturamentoClienteProduto'],
    components: {
      DashboardExcelExport: () => import('../core/ExportExcel'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      loading1: false,
      error1: null,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth() - 12, 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() - 12, 0)).toISOString().substr(0, 10),
      empresaSelect: [],
      cidades: [],
      redes: [],
      areas: [],
      vendedores: [],
      clientes: [],
      produtos: [],
      dataInicial1: (new Date(new Date().getFullYear(), new Date().getMonth() - 12, 1)).toISOString().substr(0, 10),
      dataFinal1: (new Date(new Date().getFullYear(), new Date().getMonth() - 12, 0)).toISOString().substr(0, 10),
      empresaSelect1: [],
      cidades1: [],
      redes1: [],
      areas1: [],
      vendedores1: [],
      clientes1: [],
      produtos1: [],
      clienteIds: [],
      segmento: [],
      expanded: [],
      headersFaturamento: [
        { text: 'Cliente', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Última venda', value: 'data', align: 'center', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', class: 'black--text title' },
      ],
      headersFaturamentoCliente: [
        { text: 'Cliente', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', class: 'black--text title' },
      ],
      headersFaturamentoClienteProduto: [
        { text: 'Produto', value: 'produto', align: 'left', class: 'black--text title' },
        { text: 'Última venda', value: 'data', align: 'center', class: 'black--text title' },
        { text: 'Volume', value: 'volume', align: 'right', class: 'black--text title' },
      ],
      dadosFaturamentoCliente: [],
      dadosFatClienteProduto: [],
      dadosFaturamentoClienteExcel: [],
      dadosFatClienteProdutoExcel: [],
      expandedRow: null,
      enableTable1: true,
      ordenarPorFaturamentoCliente: '',
      ordenacaoDecrescenteFaturamentoCliente: false,
      ordenarPorFaturamentoProduto: '',
      ordenacaoDecrescenteFaturamentoProduto: false,
      ordenarPorFaturamentoProdutoCliente: '',
      ordenacaoDecrescenteFaturamentoProdutoCliente: false,
      enableBtn: true,
      tituloRelatorio: 'Relatório Fluxo Venda',
      arquivo: 'relatorio_fluxo_venda.xlsx',
    }),

    created () {
      eventEmit.$on('update-form-mais-vida', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-form-mais-vida', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, vendedorSelect, redeSelect, produtoSelect, clienteSelect, dataInicial1, dataFinal1, empresaSelect1, cidadeSelect1, areaSelect1, vendedorSelect1, redeSelect1, produtoSelect1, clienteSelect1, segmento) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresaSelect = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.vendedores = vendedorSelect
        this.redes = redeSelect
        this.produtos = produtoSelect
        this.clientes = clienteSelect
        this.dataInicial1 = dataInicial1
        this.dataFinal1 = dataFinal1
        this.empresaSelect1 = empresaSelect1
        this.cidades1 = cidadeSelect1
        this.areas1 = areaSelect1
        this.vendedores1 = vendedorSelect1
        this.redes1 = redeSelect1
        this.produtos1 = produtoSelect1
        this.clientes1 = clienteSelect1
        this.segmento = segmento

        this.atualizaDados()
      },

      async atualizaDados () {
        this.loading1 = true
        this.enableTable1 = true
        this.dadosFaturamentoCliente = []
        this.dadosFatClienteProduto = []
        this.dadosFaturamentoClienteExcel = []
        this.dadosFatClienteProdutoExcel = []
        this.enableBtn = true

        await FluxoVenda.showFaturamentoClienteProduto(this.dataInicial1, this.dataFinal1, this.empresaSelect1, this.cidades1, this.areas1, this.vendedores1, this.redes1, this.clientes1, this.produtos1, localStorage.tokencontrato, this.dataInicial, this.dataFinal, this.segmento).then(resposta => {
          if (resposta.data.status) {
            this.dadosFatClienteProduto = resposta.data.dadosFaturamento.map((item) => {
              var listaDadosFaturamento = ({
                cliente: item.nome_cliente,
                data: item.ultima_venda,
                volume: item.volume,
                volumeExibicao: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                produto: item.produto,
                produtos: this.dadosProdutos(item.produtos),
              })

              return listaDadosFaturamento
            })

            this.dadosFatClienteProdutoExcel = resposta.data.dadosFaturamento.map((item) => {
              var listaDadosFaturamento = ({
                cliente: item.nome_cliente,
                volumeExibicao: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                produtos: this.dadosProdutos(item.produtos),
              })

              return listaDadosFaturamento
            })

            if (resposta.data.dadosTabela1.length === 0) {
              this.enableTable1 = false
            }

            this.dadosFaturamentoCliente = resposta.data.dadosTabela1.map((item) => {
              var listaDadosFaturamento = ({
                cliente: item.cliente,
                data: item.data,
                dataExibicao: item.dataExibicao,
                volume: item.volume,
                volumeExibicao: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
              })

              return listaDadosFaturamento
            })

            this.dadosFaturamentoClienteExcel = resposta.data.dadosTabela1.map((item) => {
              var listaDadosFaturamento = ({
                cliente: item.cliente,
                dataExibicao: item.dataExibicao,
                volumeExibicao: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
              })

              return listaDadosFaturamento
            })

            this.enableBtn = false

            eventEmit.$emit('set-dados-faturamento-cliente-tempo', this.dadosFatClienteProduto)
            eventEmit.$emit('set-dados-faturamento-cliente-produto', this.dadosFaturamentoCliente)
          } else if (resposta.data.msg === 'Não dados de valores a pagar para fornecedores no período selecionado') {
            this.dadosFaturamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error1 = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading1 = false
        })
      },

      dadosProdutos (value) {
        const produtos = value.map((item) => {
          var listaProdutos = ({
            cliente: item.nome_cliente,
            data: item.data,
            dataExibicao: item.dataExibicao,
            volume: item.volume,
            volumeExibicao: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            produto: item.produto,
          })

          return listaProdutos
        })

        return produtos
      },

      volumeExibicao (value) {
        return parseFloat(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      },

      toggleExpand (index) {
        const i = this.expanded.indexOf(index)
        if (i > -1) {
          this.expanded.splice(i, 1)
        } else {
          this.expanded.push(index)
        }
      },

      mudarOrdenacaoFaturamentoCliente (campo) {
        if (this.ordenarPorFaturamentoCliente === campo) {
          this.ordenacaoDecrescenteFaturamentoCliente = !this.ordenacaoDecrescenteFaturamentoCliente
        } else {
          this.ordenarPorFaturamentoCliente = campo
          this.ordenacaoDecrescenteFaturamentoCliente = false
        }

        this.buscarDadosFaturamentoCliente()
      },

      buscarDadosFaturamentoCliente () {
        const novaOrdenacao = [...this.dadosFaturamentoCliente]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenarPorFaturamentoCliente] < b[this.ordenarPorFaturamentoCliente]) result = -1
          if (a[this.ordenarPorFaturamentoCliente] > b[this.ordenarPorFaturamentoCliente]) result = 1

          if (this.ordenacaoDecrescenteFaturamentoCliente) result *= -1

          return result
        })

        this.dadosFaturamentoClienteExcel = novaOrdenacao.map(item => ({
          cliente: item.cliente,
          dataExibicao: item.dataExibicao,
          volumeExibicao: parseFloat(item.volume).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        }))

        this.dadosFaturamentoCliente = novaOrdenacao

        eventEmit.$emit('set-dados-faturamento-cliente-produto', novaOrdenacao)
      },

      mudarOrdenacaoFaturamentoProduto (campo) {
        if (this.ordenarPorFaturamentoProduto === campo) {
          this.ordenacaoDecrescenteFaturamentoProduto = !this.ordenacaoDecrescenteFaturamentoProduto
        } else {
          this.ordenarPorFaturamentoProduto = campo
          this.ordenacaoDecrescenteFaturamentoProduto = false
        }

        this.buscarDadosFaturamentoProduto()
      },

      buscarDadosFaturamentoProduto () {
        const novaOrdenacaoProduto = [...this.dadosFatClienteProduto]

        novaOrdenacaoProduto.sort((a, b) => {
          let result = 0

          if (a[this.ordenarPorFaturamentoProduto] < b[this.ordenarPorFaturamentoProduto]) result = -1

          if (a[this.ordenarPorFaturamentoProduto] > b[this.ordenarPorFaturamentoProduto]) result = 1

          if (this.ordenacaoDecrescenteFaturamentoProduto) result *= -1

          return result
        })

        this.dadosFatClienteProdutoExcel = novaOrdenacaoProduto

        this.dadosFatClienteProduto = novaOrdenacaoProduto

        this.expanded = []

        eventEmit.$emit('set-dados-faturamento-cliente-tempo', novaOrdenacaoProduto)
      },

      mudarOrdenacaoFaturamentoProdutoCliente (item, options) {
        const { sortBy, sortDesc } = options

        if (sortBy.length === 0) {
          return []
        }

        const sortedProdutos = item.produtos.sort((a, b) => {
          const sortKey = sortBy[0]

          let result = 0

          if (a[sortKey] < b[sortKey]) result = -1
          if (a[sortKey] > b[sortKey]) result = 1
          if (sortDesc[0]) result = -result

          return result
        })

        item.produtos = sortedProdutos

        this.mudarOrdenacaoItemProdutoCliente(item, sortedProdutos)
      },

      mudarOrdenacaoItemProdutoCliente (item, sortedProdutos) {
        const index = this.dadosFatClienteProduto.findIndex(dado => dado.cliente === item.cliente)

        if (index !== -1) {
          this.$set(this.dadosFatClienteProduto, index, { ...item, produtos: sortedProdutos })
        }

        this.dadosFatClienteProdutoExcel = this.dadosFatClienteProduto

        eventEmit.$emit('set-dados-faturamento-cliente-tempo', this.dadosFatClienteProduto)
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 401px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  #textTable {
    font-size: 0.75rem !important
  }

  #textoFaturamento{
    margin: -2rem 0 0 0
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
